import { useState, useEffect } from "react";
import { setDoc, doc, getDoc, updateDoc } from "firebase/firestore";
import { db, applicantsCol } from "../../firebase";
import "../../dash.css";
import { useUser } from "../../UserContext";

export const Kin_or_Relative_info = ({ onSuccess }) => {
  const { user, loading: userLoading } = useUser();
  const userID = user?.uid || "";
  const [isNewApplicant, setIsNewApplicant] = useState(true);
  const [hasSavedKinInfo, setHasSavedKinInfo] = useState(false);
  const [issavingData, setIssavingData] = useState(false);
  const [disableInputFields, setDisableInputFields] = useState(false);
  const [message, setMessage] = useState("");
  const [isErrorOrSuccMsg, setIsErrorOrSuccMsg] = useState(false);
  const [isErrorMsg, setIsErrorMsg] = useState(false);
  const [formData, setformData] = useState({
    kinfName: "",
    kinMname: "",
    kinlName: "",
    kinEmail: "",
    kinPhoneNo: "",
    relation: "",
  });
  const [loading, setIsloading] = useState(false);

  // get applicants details if aready registered
  useEffect(() => {
    if (!userID) return;
    const fetchApplicantDetails = async () => {
      setIsloading(true);
      const applicantRef = doc(db, applicantsCol, userID);
      const registeredApplicant = await getDoc(applicantRef);
      if (registeredApplicant.exists()) {
        setIsNewApplicant(false);
        setHasSavedKinInfo(true);
      const data = registeredApplicant.data();
      if (data.savedKinInfo) {
        setHasSavedKinInfo(true);
        setDisableInputFields(true);
        setformData((prev) => ({
          ...prev,
          kinfName: data.kinfName,
          kinMname: data.kinMname,
          kinlName: data.kinlName,
          kinEmail: data.kinEmail,
          kinPhoneNo: data.kinPhoneNo,
          relation: data.relation,
        }));
        setIsloading(false);
      } else {
        setIsloading(false);
        setHasSavedKinInfo(false);
        setDisableInputFields(false);
      }
      } else {
        setIsloading(false);
        setIsNewApplicant(true);
        setDisableInputFields(false);
      }
    };

    fetchApplicantDetails();
  }, [userID]);

  const handleChange = (e) => {
    setformData((prev) => ({
      ...prev,
      savedKinInfo: true,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIssavingData(true);

    try {
      if (isNewApplicant) {
        await setDoc(doc(db, applicantsCol, userID), formData);
        setIssavingData(false);
        setIsErrorOrSuccMsg(true);
        setIsErrorMsg(false);
        setMessage("information saved successfully");
        setDisableInputFields(true);
        if (typeof onSuccess === "function") {
          onSuccess();
        }
      } else {
        const applicantRef = doc(db, applicantsCol, userID);
        await updateDoc(applicantRef, formData);
        setIssavingData(false);
        setIsErrorOrSuccMsg(true);
        setIsErrorMsg(false);
        setDisableInputFields(true);
        hasSavedKinInfo?setMessage("information updated successfully"):setMessage("information saved successfully");
        // if (typeof onSuccess === "function") {
        //   onSuccess();
        // }
      }
    } catch (error) {
      setIssavingData(false);
      setIsErrorOrSuccMsg(true);
      setIsErrorMsg(true);
      setMessage("something went wrong, try again"+ error);
    }
  };

  const enableFields = () => {
    setDisableInputFields(false);
    setIsErrorOrSuccMsg(false);
    setHasSavedKinInfo(false);
  };

  if (loading) return <div className="loader"></div>;

  return (
    <div className="form-container personal-info">
      {isErrorOrSuccMsg ? (
        <div
          className={`alert alert-${isErrorMsg ? "danger" : "success"}`}
          role="alert"
        >
          {message}
        </div>
      ) : (
        <span></span>
      )}
      <h2 className="form-title">KIN OR RELATIVE INFORMATION</h2>
      {/* <span style={{color}}>{message}</span> */}
      {disableInputFields ? (
        <button className="btn btn-primary" onClick={enableFields}>
          CHANGE
        </button>
      ) : (
        <span></span>
      )}

      <form onSubmit={handleSubmit}>
        <div className="details">
          <div className="form-fields">
            <label>
              first name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter first  name"
              name="kinfName"
              value={formData.kinfName}
              onChange={handleChange}
              required
              maxLength={50}
              disabled={disableInputFields}
            />
          </div>
          <div className="form-fields">
            <label>
              middle name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter middle  name"
              name="kinMname"
              value={formData.kinMname}
              onChange={handleChange}
              required
              maxLength={50}
              disabled={disableInputFields}
            />
          </div>
          <div className="form-fields">
            <label>
              last name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter  last  name"
              name="kinlName"
              value={formData.kinlName}
              onChange={handleChange}
              required
              maxLength={50}
              disabled={disableInputFields}
            />
          </div>
          <div className="form-fields">
            <label>
              relationship <span style={{ color: "red" }}>*</span>
            </label>
            <select
              name="relation"
              id="relation"
              value={formData.relation}
              onChange={handleChange}
              disabled={disableInputFields}
              required
            >
              <option value="">--choose relationship--</option>
              <option value="father">father</option>
              <option value="mother">mother</option>
              <option value="brother">brother</option>
              <option value="sister">sister</option>
              <option value="uncle">uncle</option>
              <option value="aunt">aunt</option>
              <option value="cousin">cousin</option>
              <option value="husband">husband</option>
              <option value="wife">wife</option>
              <option value="other">other</option>
            </select>
          </div>

          <div className="form-fields">
            <label>
              email
            </label>
            <input
              type="email"
              name="kinEmail"
              value={formData.kinEmail}
              onChange={handleChange}
              placeholder="Enter kinemail"
              disabled={disableInputFields}
            />
          </div>

          <div className="form-fields">
            <label>phone number <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="kinPhoneNo"
              value={formData.kinPhoneNo}
              onChange={handleChange}
              placeholder="phone number"
              disabled={disableInputFields}
              required
            />
          </div>
        </div>
        {disableInputFields ? (
          <span></span>
        ) : issavingData ? (
          <div className="loader"></div>
        ) : (
          <button
            type="submit"
            style={hasSavedKinInfo   ? { background: "green" } : {}}
          >
            {hasSavedKinInfo ? "update" : "save"}
          </button>
        )}
      </form>
    </div>
  );
};
